<div id="home">
  <div class="section home" id="section">
    <div class="big-button" (click)="goToSpaHome()">
      <div class="img-button">
        <img src="../../../../assets/img/spa.svg" alt="Spa" />
      </div>
      <button class="my-button filled">
        {{ "home.spa" | translate }}
      </button>
    </div>

    <div class="big-button" (click)="goToTenderHome()">
      <div class="img-button">
        <img src="../../../../assets/img/categorie/tender.svg" alt="Tender" />
      </div>
      <button class="my-button filled">
        {{ "home.tender" | translate }}
      </button>
    </div>

    <!--<div class="big-button" (click)="goToUrl(reservation_url)">
            <div class="img-button">
                <img src="../../../../assets/img/ticket.svg" alt="Ticket">
            </div>
            <button class="my-button outline">{{'home.my_reservations' | translate}}</button>
        </div>-->
  </div>
</div>
